import { Button } from '../ui/button';
import { GoArrowLeft, GoArrowRight } from 'react-icons/go';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';
import { toast } from 'sonner';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Form, FormControl, FormField, FormItem, FormMessage } from '../ui/form';
import { useEffect, useState } from 'react';
import Partners from './Partners';
import { useLocalStorage } from 'usehooks-ts';
import { useSession } from '@/contexts/LitSessionProvider';
export const OPTValidationSchema = z.object({
  code: z.string().min(6, {
    message: 'Your referral code must be at least 6 characters long'
  })
});
export default function ReferralCodeInput({
  handleUseReferralCode,
  referralUrlCode = '',
  clearLitSession
}) {
  const [loading, setLoading] = useState(false);
  const {
    PKP
  } = useSession();
  const [disableRef, setDisableRef] = useLocalStorage(`disableRef-${PKP?.ethAddress}`, false);
  const [askPage, setAskPage] = useState(true);
  useEffect(() => {
    async function preFill() {
      setLoading(true);
      if (referralUrlCode && referralUrlCode !== '') {
        await handleUseReferralCode(referralUrlCode);
        if (!global?.appliedCode) {
          toast.success('Referral code applied successfully. Welcome to Genius!');
          global.appliedCode = true;
        }
      } else {
        // toast.error('Please enter a referral code');
      }
      setLoading(false);
    }
    preFill();
  }, [referralUrlCode]);
  const formCode = useForm<z.infer<typeof OPTValidationSchema>>({
    resolver: zodResolver(OPTValidationSchema),
    defaultValues: {
      code: referralUrlCode
    }
  });
  const ValidateOTP = async (values: z.infer<typeof OPTValidationSchema>) => {
    setLoading(true);
    if (values && values.code) {
      await handleUseReferralCode(values.code);
    } else {
      console.log('Please enter a referral code');
      // toast.error('Please enter a referral code');
    }
    setLoading(false);
  };
  return <div className='min-h-screen  justify-center px-6 ta-c w-full bg-[#09001A]' data-sentry-component="ReferralCodeInput" data-sentry-source-file="ReferralCodeInput.tsx">
      <h2 className='text-[24px] text-genius-gradient-normal mt-6'>Do you have a referral code?</h2>
      <div className='md:mx-12 text-sm'>
        You and your referrer earn Genius Points. You can add a referral code at a later time from
        your account settings.
      </div>
 
      {askPage ? <div className='flex flex-col'>
          <Button onClick={() => setAskPage(false)} variant='pink' className='px-6 text-[16px]  mt-12 h-[56px] pink-shadow rounded-full bg-genius-pink md:hover:bg-genius-pink text-genius-blue text-center flex items-center justify-center'>
           I have a referral code 
          </Button>
          <Button onClick={() => setDisableRef(true)} variant='ghost' className='px-6 text-[16px]   h-[56px] mt-2 pink-shadow rounded-full bg-genius-blue text-genius-pink md:hover:bg-genius-blue  text-center flex items-center justify-center'>
            Continue without referral code 
          </Button>
        </div> : <div className='mt-12 '>
          <Form {...formCode}>
            <form onSubmit={formCode.handleSubmit(ValidateOTP)} className='w-full max-auto space-y-6'>
              <FormField control={formCode.control} name='code' render={({
            field
          }) => <FormItem className='OPTInputs'>
                    <FormControl>
                      <InputOTP maxLength={6} {...field}>
                        <InputOTPGroup>
                          <InputOTPSlot index={0} />
                          <InputOTPSlot index={1} />
                          <InputOTPSlot index={2} />
                          <InputOTPSlot index={3} />
                          <InputOTPSlot index={4} />
                          <InputOTPSlot index={5} />
                        </InputOTPGroup>
                      </InputOTP>
                    </FormControl>
                    <FormMessage />
                  </FormItem>} />
              <Button disabled={loading} variant='pink' className='px-6  text-[16px] mt-10 w-[95%] h-[56px] pink-shadow rounded-full justify-between flex items-center bg-genius-pink md:hover:bg-genius-pink text-genius-blue' type='submit'>
                {referralUrlCode && referralUrlCode.length > 5 ? 'Activating Genius...' : 'Enter invite code'}{' '}
                <GoArrowRight className='w-[16px]' />
              </Button>
              <Button disabled={loading} variant='pink' onClick={() => setAskPage(true)} className='px-6 text-[16px] mt-[5px!important] w-[95%] h-[56px] pink-shadow rounded-full justify-between flex items-center bg-genius-pink md:hover:bg-genius-pink text-genius-blue' type='submit'>
                Go Back
                <GoArrowRight className='w-[16px]' />
              </Button>
            </form>
          </Form>
          <Partners />
        </div>}
           <p onClick={() => clearLitSession()} className='text-[16px] text-genius-gradient-normal mt-6 font-light flex items-center justify-center ta-c mr-2 cursor-pointer'>
        <GoArrowLeft className='w-[18px] h-[18px] mr-3 text-genius-cream' data-sentry-element="GoArrowLeft" data-sentry-source-file="ReferralCodeInput.tsx" /> Log out
      </p>
    </div>;
}